// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__K1ODi","actionColumn":"ReferralSources_actionColumn__36INA","textButton":"ReferralSources_textButton__2G_Tb"};